module.exports = __webpack_public_path__ + "static/media/ar.d41fb998.svg";